import { Heading } from '@sparemin/blockhead';
import React from 'react';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';

export type YouTubeElegibleAccountStepProps = {};

const YouTubeElegibleAccountStep: React.FC<YouTubeElegibleAccountStepProps> = () => {
  return (
    <SocialShareModalBody showRegenerateTextButton={false}>
      <Heading level={2} align="center">
        To ensure all your videos get posted, let's quickly hop over to YouTube
        to verify your account. If we don't then some of your videos might get
        blocked during posting.
      </Heading>
    </SocialShareModalBody>
  );
};

export default YouTubeElegibleAccountStep;
